import request from '@/utils/request'
import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'

// 获取人才信息
export function getUserInfo(params, data) {
  const url = handlerGetUrlParams('/system/user/list', params)
  return request({
    url,
    method: 'POST',
    data
  })
}
// export function getTradingInfo(params, data) {
  
//   // console.log(data)
//   return request({
//     url,
//     method: 'POST',
//     data
//   })
// }

// 启用停用用户
export function statusUserInfo(data) {
  return request({
    url: '/system/user/batchChangeStatus',
    method: 'PUT',
    data
  })
}

// 添加新用户
export function addUserInfo(data) {
  return request({
    url: '/system/user',
    method: 'POST',
    data
  })
}

// 删除用户
export function deleteUserInfo(params) {
  return request({
    url: `/system/user/${params}`,
    method: 'DELETE'
  })
}

// 导入用户信息
export function importUserInfo(data) {
  return request({
    url: '/system/user/importData',
    method: 'POST',
    data
  })
}

// 信息发布
export function msgPublic(data) {
  // const url = handlerGetUrlParams('/bus/msgPublic/counts')
  return request({
    url:'/bus/msgPublic/counts',
    method: 'POST',
    data
  })
}

// 获取用户ip
export function ipView(params) {
  return request({
    url: '/bus/ipView/is_view/'+String(params),
    method: 'GET'
  })
}
// 根据时间段获取月访问总量
export function monthsCount(data) {
  return request({
    url: '/bus/ipView/months_count',
    method: 'POST',
    data
  })
}